




































































































































































import Vue, { PropType } from 'vue';
import { Logo, Icon, Button } from '@/components/ds';
import PipelineMenuItemPosition from './PipelineMenuItemPosition.vue';

interface PipelineItem {
  title: string;
  steps: string[];
  childrenActive: boolean;
  children: { title: string; steps: string[]; hidden?: boolean }[];
}

export default Vue.extend({
  components: {
    Logo,
    Icon,
    PipelineMenuItemPosition,
    Button,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: String,
      required: true,
    },
    pipelineItems: {
      type: Array as PropType<PipelineItem[]>,
      required: true,
    },
    stepHistory: {
      type: Array as PropType<string[]>,
      required: true,
    },
    smallMobileItems: {
      type: Boolean,
      default: false,
    },
    withFooterButton: {
      type: Boolean,
      default: false,
    },
    footerButtonText: {
      type: String,
      required: false,
      default: '',
    },
    footerButtonIcon: {
      type: String,
      required: false,
      default: '',
    },
    footerButtonMobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: this.pipelineItems as PipelineItem[],
      showSideMenuMobile: false,
      hasScroll: false,
    };
  },
  computed: {
    cssVars(): any {
      return {
        '--items-offset': this.smallMobileItems ? '16px' : '32px',
        '--top-justify': this.smallMobileItems ? 'center' : 'flex-start',
        '--overflow-x': this.collapsed ? 'hidden' : 'auto',
      };
    },
  },
  watch: {
    pipelineItems(value) {
      this.items = value;
    },
  },
  mounted(): void {
    window.addEventListener('scroll', this.setHasScroll);
  },
  beforeDestroy(): void {
    window.removeEventListener('scroll', this.setHasScroll);
  },
  methods: {
    goToStep(steps: string[]): void {
      this.$emit('goToStep', steps[0]);
    },
    isCurrentStep(steps: string[]): boolean {
      return steps.includes(this.currentStep);
    },
    isDropDownEnabled(index: number): boolean {
      const item = this.items[index];
      const hasChildren = item.children.length > 0;
      const isStepVisited = this.isStepVisited(item.steps, false);
      const isCurrentStep = this.isCurrentStep(item.steps);

      return hasChildren && isStepVisited && !item.childrenActive && !isCurrentStep;
    },
    isDropUpEnabled(index: number): boolean {
      const item = this.items[index];
      const hasChildren = item.children.length > 0;
      const isCurrentStep = this.isCurrentStep(item.steps);

      return hasChildren && (item.childrenActive || isCurrentStep);
    },
    isStepVisited(steps: string[], strict = true): boolean {
      const arrayFn = strict ? 'every' : 'some';
      return steps[arrayFn](step => this.stepHistory.includes(step));
    },
    toggleChildren(index: number, active: boolean): void {
      if (this.isCurrentStep(this.items[index].steps)) return;

      this.items[index].childrenActive = active;
    },
    setHasScroll(): void {
      this.hasScroll = window.scrollY > 0;
    },
    toggleSideMenuMobile(): void {
      this.showSideMenuMobile = !this.showSideMenuMobile;
    },
    onFooterButtonClick(): void {
      this.$emit('onFooterButtonClick');
    },
  },
});
